var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3,19.1h-.7c-.1,0-.2,0-.3,0-.4-.1-.7-.3-1.2-.6l-4.8-2.7c-.4-.2-.6-.4-.9-.6,0,0-.1-.2-.2-.3,0,0,0,0,0,0-.1-.2-.3-.5-.3-1v-7.5c0-.3.1-.8.6-1.3.3-.3.5-.4.9-.6h.2c0-.1,4.6-2.8,4.6-2.8,0,0,.2-.1.3-.2.3-.2.7-.4,1.2-.4h.7c.1,0,.2,0,.3,0,.4.1.7.3,1.2.6l4.8,2.7c.4.2.6.4.9.6,0,0,.1.2.2.3,0,0,0,0,0,0,.1.2.3.5.3,1v7.5c0,.3-.1.8-.6,1.3-.3.3-.5.4-.9.6h-.2c0,.1-4.6,2.7-4.6,2.7-.1,0-.2.1-.3.2-.3.2-.7.4-1.2.4ZM9.8,17.1h.4c0,0,.1,0,.2-.1.1,0,.2-.1.4-.2h0s4.8-2.7,4.8-2.7c.3-.2.4-.2.5-.3,0,0,0,0,0,0v-7.2s0,0,0,0c0,0,0,0,0-.1,0,0-.2-.1-.4-.2h-.2c0-.1-4.6-2.7-4.6-2.7-.4-.2-.5-.3-.7-.4h-.4c0,0-.1,0-.2.1-.1,0-.2.1-.4.2l-4.9,2.7c-.3.2-.4.2-.5.3s0,0,0,0v7.2s0,0,0,0c0,0,0,0,0,.1,0,0,.2.1.4.2h.2c0,.1,4.6,2.7,4.6,2.7.4.2.5.3.7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,13.5c-2,0-3.5-1.5-3.5-3.5s1.5-3.5,3.5-3.5,3.5,1.5,3.5,3.5-1.5,3.5-3.5,3.5ZM10,8.5c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5,1.5-.7,1.5-1.5-.7-1.5-1.5-1.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFuture);
export default __webpack_public_path__ + "static/media/Settings_Future.be501fd6b8eb47df4173f16f65411bbb.svg";
export { ForwardRef as ReactComponent };